<template>
  <section class="container">
    <div v-if="isPress" class="pure-u-1">This is the PRINT form.</div>
    <a href="#" v-on:click.stop.prevent="cancelUpdateGrape" v-if="formType == 'edit-inline'" class="grape-edit-close"><i class="fal fa-times"></i></a>
    <div id="share-screenshot">
    </div>
    <div id="grape-capture">
        <h4 class="grape-author">{{this.sourceAuthor}}</h4>   
        <h3 class="grape-title">{{this.grapeTitle}}</h3>
        <span class="grape-source">{{this.grapeSource}}</span>
        <div class="grape-content-wrap">
          <div class="grape-content-preview-overlay"></div>
          <div class="grape-content">Content</div>
        </div>
        <div class="grapevine-link">
          <a href="https://atgrapevine.com" target="_blank">atgrapevine.com</a>
        </div>
    </div>
    <div :id="'grape-' + grapeID" :data-doc-id="docID" class="grape-form-wrap pure-g" :data-form-type="formType">
      <form @submit.prevent="validateGrape" novalidate class="pure-form pure-form-stacked pure-u-1-2" :data-edit-type="formType">
        <fieldset>

          <router-link :to="{ name: 'edit-grape', params: { grapeID: grapeID }}" class="direct-edit-link" v-if="formType == 'edit-inline' && !isPress">Click here to change source or upload a fresh book page.</router-link>

          <div class="input-field" v-if="isPress">
            <label for="grape_publication">Publication</label>
            <select name="grape_publication" class="material-select" id="grape_publication" v-model="grapePublication" required>
              <option value="The Times">The Times</option>
              <option value="Guardian">Guardian</option>
              <option value="Telegraph">Telegraph</option>
              <option value="Independent">Independent</option>
              <option value="Financial Times">Financial Times</option>
              <option value="Economist">Economist</option>
              <option value="New Statesman">New Statesman</option>
              <option value="Spectator">Spectator</option>
              <option value="LRB">LRB</option>
              <option value="TLS">TLS</option>
              <option value="Granta">Granta</option>
              <option value="Prospect">Prospect</option>
              <option value="GQ">GQ</option>
              <option value="Wired">Wired</option>
              <option value="New Scientist">New Scientist</option>
              <option value="Atlantic">Atlantic</option>
              <option value="Harpers">Harper's</option>
            </select>
          </div>

          <div class="input-field" v-if="formType != 'edit-inline' && !isPress">
            <label for="grape_type">Grape Type</label>
            <select name="grape_type" class="material-select" id="grape_type" v-model="grapeType" required>
              <option value="book">Book</option>
              <option value="url">YouTube</option>
            </select>
          </div>

          <div class="input-field input-field-half-left" v-if="formType != 'edit-inline' && grapeType == 'book' && !isPress">
            <label for="grape_source_title">Title <span>Powered by <img src="../assets/img/2000px-Google_2015_logo.svg.png" /> Books API</span></label>        
            <input name="grape_source_title" placeholder="" id="grape_source_title" type="text" class="validate tooltip" v-model="grapeSourceTitle" autocomplete="off" required title="start typing book title <br/> or search “[title]” & “[author] <br/> or try “[title]” & “edition” or “classic”">
          </div>

          <div class="input-field input-field-half-right input-field-source" v-if="formType != 'edit-inline' && grapeType == 'book' && !isPress">
            <label for="grape_source_author">Author</label>        
            <input name="grape_source_author" placeholder="" id="grape_source_author" type="text" class="validate tooltip" v-model="grapeSourceAuthor" autocomplete="off" title="Enter the author's name here<br/> to narrow the search">
          </div>

          <div class="input-field source-input-field input-field-half-left" v-if="(formType != 'edit-inline' && grapeType == 'url') || isPress">
            <label for="grape_source">URL</span></label>        
            <input name="grape_source" placeholder="" id="grape_source" type="text" class="validate" v-model="grapeSource" autocomplete="off" required>
          </div>

          <div class="input-field input-field-half-right input-field-source" v-if="isPress || grapeType == 'url'">
            <label for="grape_source_author">Author</label>        
            <input name="grape_source_author" placeholder="" id="grape_source_author" type="text" class="validate" v-model="grapeSourceAuthor" autocomplete="off">
          </div>

          <div class="input-field print-upload-source-image" v-if="isPress">
            <img :src="sourceImage" v-if="sourceImage" />
            <label for="upload_source_image">Source image override</label>
            <input type="file" name="upload_source_image" id="upload_source_image" />
          </div>

          <button class="btn waves-effect waves-light" name="get_books" id="get_books" v-on:click.stop.prevent="getBooks()" v-if="formType != 'edit-inline'">Get Books</button>
          <router-link :to="{ name: 'book', params: { title: encodeURI(grapeSourceTitle), id: sourceID }}" class="book-grape-count" v-if="grapesFromBookCount > 0 && grapesFromBookCount < 10">There are currently <span>{{grapesFromBookCount}}</span> grapes from this book.</router-link>
          <a href="#" class="book-grape-count" v-if="grapesFromBookCount > 0 && grapesFromBookCount >= 10" v-on:click.stop.prevent="grapeLimitReached()">There are currently <span>{{grapesFromBookCount}}</span> grapes for this book, unfortunately at this time we are unable to accept any further grapes.</a>

          <div class="mobile-source-preview-wrap source-preview-wrap" v-if="formType != 'edit-inline'">
          </div>

          <div class="input-field hidden">
            <label for="grape_source">Source <span>Powered by <img src="../assets/img/2000px-Google_2015_logo.svg.png" /> Books API</span></label>
            <input name="grape_source" placeholder="" id="grape_source" type="text" class="validate tooltip" autocomplete="off" v-model="grapeSource" required title="start typing book title <br/> or search “[title]” & “[author] <br/> or try “[title]” & “edition” or “classic”">
          </div>

          <div class="input-field hidden">
            <label for="source_author">Author</label>
            <input name="source_author" placeholder="" id="source_author" type="text" autocomplete="off" maxlength="40" v-model="sourceAuthor" required>
          </div>

          <div style="height: auto; overflow: hidden; clear: both;"></div>
          <hr class="grape-form-divide">

          <div class="input-field the-grape-input">
            <button class="pure-button delete-text-button">Delete text</button>
            <button class="pure-button reupload-button">Process images</button>

            <label for="grape_content">The Grape</label>
            <span v-if="formType != 'edit-inline'">Upload a book page</span>
            <input type="file" id="upload_scan" multiple title="take pic of book pages <br/>crop relevant passage <br/>pics convert in order taken" v-if="formType != 'edit-inline'"/>
            <span v-if="formType != 'edit-inline'">or write below</span>
            <div id="toolbar">
              <button class="ql-bold"></button>
              <button class="ql-italic"></button>
              <button class="ql-underline"></button>
              <div class="toolbar-spacer"></div>
              <button class="ql-align"></button>
              <button class="ql-list" value="bullet"></button>
              <button class="ql-indent" value="-1"></button>
              <button class="ql-indent" value="+1"></button>
              <div class="toolbar-spacer"></div>
              <button id="omission-button"><i class="fal fa-genderless"></i></button>
              <button id="paragraph-remove-button"><i class="fal fa-angle-double-left"></i></button>
              <button id="paragraph-insert-button"><i class="fal fa-angle-double-right"></i></button>
            </div>
            <textarea name="grape_content" id="grape_content" class="textarea" required></textarea>
            <div class="spacer"></div>
            <div id="grape_editor" class="editor-tooltip" :data-id="grapeID" title="please use the formatting of the author <br/>use the circle (or a +) if you have omitted any words <br/>use the arrows (or > and <) to add or remove a paragraph"></div>
            <div class="word-count"><span>0</span> words - must be between 100-550</div>
          </div>

          <div class="input-field">
            <label for="grape_title">Title</label>    
            <input name="grape_title" placeholder="" id="grape_title" type="text" class="validate tooltip" v-model="grapeTitle" autocomplete="off" maxlength="50" v-on:keyup="checkGrapeTitle" required title="ideally titles are direct, simple, rhythmic & avoid jargon">
            <p class="title-notice">{{titleNotice}}</p>
          </div>

          <div class="form-divider">
            <span>Optional</span>
          </div>

          <div class="input-field">
            <label for="grape_notes">Note</label>
            <textarea name="grape_notes" id="grape_notes" class="textarea tooltip" v-model="grapeNotes" maxlength="150" rows="3" title="add context: who are these characters?"></textarea>
          </div>

          <div class="input-field input-field-half-left">
            <label for="grape_original_publish_year">Year first published</label>        
            <input name="grape_original_publish_year" placeholder="" id="grape_original_publish_year" type="text" class="validate tooltip" maxlength="40" v-model="grapeOriginalPublishYear" autocomplete="off" title="when first published and/or written?">
          </div>

          <div class="input-field input-field-half-right" v-if="!isPress">
            <label for="grape_translation">Translation</label>        
            <input name="grape_translation" placeholder="" id="grape_translation" type="text" class="validate tooltip" v-model="grapeTranslation" maxlength="40" autocomplete="off" title="please credit the translator">
          </div>

          <div class="clear"></div>

          <div class="input-field hidden">
            <label for="grape_labels">Tags</label>
            <ul id="grape_labels">
            </ul>
          </div>

          <div class="input-field hidden data-fields">
            <textarea name="original_content" id="original_content" type="hidden" v-model="originalContent"></textarea>
            <input name="user_id" placeholder="" id="user_id" type="hidden" autocomplete="off" v-model="userID">
            <input name="username" placeholder="" id="username" type="hidden" autocomplete="off" v-model="username">
            <input name="source_id" placeholder="" id="source_id" type="hidden" autocomplete="off" v-model="sourceID">
            <input name="source_description" placeholder="" id="source_description" type="hidden" autocomplete="off" v-model="sourceDescription">
            <input name="source_isbn" placeholder="" id="source_isbn" type="hidden" autocomplete="off" v-model="sourceISBN">
            <input name="source_image" placeholder="" id="source_image" type="hidden" autocomplete="off" v-model="sourceImage">
            <input name="source_date" placeholder="" id="source_date" type="hidden" autocomplete="off" v-model="sourceDate">
          </div>

          <p class="submit-notice">{{submitNotice}}</p>

          <button class="btn waves-effect waves-light" id="grape_submit" type="submit" name="action" v-on:click.stop.prevent="validateGrape">Submit</button>
          <button class="btn waves-effect waves-light cancel-button" v-on:click.stop.prevent="cancelUpdateGrape" v-if="formType == 'edit-inline'">Cancel</button>
        </fieldset>
      </form>

      <div class="desktop-source-preview-wrap source-preview-wrap pure-u-1-2" v-if="formType != 'edit-inline'">
        <div class="source-preview-inner">
          <h4 v-if="grapeType =='book'">Books returned <span>please select the book</span> <a href="#" class="source-preview-back pure-button">Back</a></h4>
          <div id="books-table-wrap" v-if="grapeType =='book'">
            <table id="books-table">
              <tbody>
              </tbody>
            </table>
          </div>

          <div id="source-preview">

          </div>
          <div id="selected-image-wrap">
            <div class="images">
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  /* global $, jQuery, algoliasearch, Quill, ImageCompressor, mixpanel */
  import firebase from 'firebase'
  import db from './firebaseInit'
  import Router from '../router'
  import html2canvas from 'html2canvas'
  const crypto = require('crypto');

  export default {
    name: 'GrapeForm',
    data () {
      return {
        grapeData: [],
        grapeType: 'book',
        bookResults: [],
        grapeSource: null,
        grapeSourceTitle: '',
        grapeSourceAuthor: '',
        grapeTitle: null,
        grapeNotes: null,
        grapePublication: null,
        grapeOriginalPublishYear: null,
        grapeTranslation: null,
        originalContent: null,
        sourceID: null,
        sourceDescription: null,
        sourceISBN: null,
        sourceImage: null,
        sourceAuthor: null,
        sourceDate: null,
        grapeID: null,
        username: null,
        isLoggedIn: false,
        titleNotice: '',
        submitNotice: '',
        userID: null,
        grapesFromBookCount: 0,
        docID: null,
        shareImageBlob: null,
        editedGrapeContent: null,
        setContentInterval: null,
        isPress: this.$globals.isPress
      }
    },
    props: {
      grapeInstance: {
        type: Object,
        required: false,
        mustProcess: false
      },
      grapeKey: null,
      grapeKeyID: null,
      formType: null,
      editGrapeID: null
    },
    created () {
      let quillScript = document.createElement('script')
      quillScript.setAttribute('src', '//cdn.quilljs.com/1.3.4/quill.min.js')
      quillScript.async = true
      document.head.appendChild(quillScript)
      let ajaxqScript = document.createElement('script')
      ajaxqScript.setAttribute('src', '/static/js/ajaxq.js')
      ajaxqScript.async = true
      document.head.appendChild(ajaxqScript)
      let imageCompressorScript = document.createElement('script')
      imageCompressorScript.setAttribute('src', '/static/js/image-compressor.min.js')
      imageCompressorScript.async = true
      document.head.appendChild(imageCompressorScript)

      var vm = this
      if (vm.formType === 'new') {
        vm.grapeID = 'new'
      }
      firebase.auth().onAuthStateChanged(function (user) {
        if (user) {
          vm.userID = user.uid
          firebase.database().ref('users/' + user.uid).once('value', function (snapshot) {
            vm.username = snapshot.val().username
          })
          vm.isLoggedIn = true
        }
      })

      if (vm.formType === 'edit-direct') {
        vm.fetchDirectEdit()
      } else if (vm.formType === 'edit-inline') {
        vm.fetchDirectEdit()
      }
    },
    methods: {
      showLoading () {
        $('body').addClass('pace-running')
        $('.pace').addClass('pace-active')
        $('.pace-opt').addClass('show-opt')
      },
      hideLoading () {
        $('body').removeClass('pace-running')
        $('.pace').removeClass('pace-active')
        $('.pace-opt').removeClass('show-opt')
      },
      createShareModal () {
        let vm = this
        $("#grape-capture").find('.grape-content').html(this.getGrapeContent())
        html2canvas(document.querySelector("#grape-capture"), {allowTaint: false}).then(canvas => {
          $('#share-screenshot').empty()
          $('#share-screenshot').append(canvas)
          var img = canvas.toDataURL("image/jpeg")
          $('#share-screenshot').append('<img src="'+img+'"/>')
          vm.shareImageBlob = vm.getCanvasBlob(canvas)
          vm.shareImageBlob.then(function(blob) {
            vm.uploadShareImage()
          }, function(err) {
            console.log(err)
          })
        })
      },
      getCanvasBlob (canvas) {
        return new Promise(function (resolve, reject) {
          canvas.toBlob(function (blob) {
            resolve(blob)
          }, 'image/jpeg', 0.95)
        })
      },
      uploadShareImage () {
        let vm = this
        var storageRef = firebase.storage().ref()
        var shareImageRef = storageRef.child('shareImages/' + 'testImage' + '.jpg')
        shareImageRef.put(vm.shareImageBlob).then(function (snapshot) {
          console.log('Uploaded a blob or file!')
        });
      },
      fetchDirectEdit () {
        let vm = this
        console.log('fetchDirectEdit, form type: ' + vm.formType)
        if (this.isPress) {
          db.collection('proGrapes').where('id', '==', vm.editGrapeID).get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              console.log('fetch: ' + doc.id, ' => ', doc.data())
              vm.docID = doc.id
              vm.grapeID = doc.data().id
              vm.grapeTitle = doc.data().grapeTitle
              vm.originalContent = doc.data().grapeContent
              vm.grapeNotes = doc.data().grapeNotes
              vm.grapeOriginalPublishYear = doc.data().grapeOriginalPublishYear
              vm.grapeSource = doc.data().grapeSource
              vm.grapeSourceAuthor = doc.data().sourceAuthor
              vm.grapePublication = doc.data().grapePublication
              vm.sourceImage = doc.data().sourceImage

              /* Add content to editor */
              if (vm.formType === 'edit-inline') {
                vm.createEditor()
                vm.editedGrapeContent = doc.data().grapeContent
                vm.setContentInterval = setInterval(vm.checkToLoadContent, 50)
              } else {
                vm.editedGrapeContent = doc.data().grapeContent
                vm.setContentInterval = setInterval(vm.checkToLoadContent, 50)
              }
            })
            // vm.getGrapeTags()
          })
        } else {
          db.collection('grapes').where('id', '==', vm.editGrapeID).get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              console.log('fetch: ' + doc.id, ' => ', doc.data())
              vm.docID = doc.id
              vm.grapeID = doc.data().id
              vm.grapeType = doc.data().grapeType
              vm.grapeTitle = doc.data().grapeTitle
              vm.originalContent = doc.data().grapeContent
              vm.grapeNotes = doc.data().grapeNotes
              vm.grapeOriginalPublishYear = doc.data().grapeOriginalPublishYear
              vm.grapeTranslation = doc.data().grapeTranslation
              vm.grapeSource = doc.data().grapeSource
              vm.grapeSourceTitle = doc.data().grapeSource
              vm.grapeSourceAuthor = doc.data().sourceAuthor
              vm.sourceID = doc.data().sourceID
              vm.sourceDate = doc.data().sourceDate
              vm.sourceAuthor = doc.data().sourceAuthor
              vm.sourceImage = doc.data().sourceImage
              vm.sourceISBN = doc.data().sourceISBN

              /* Add content to editor */
              if (vm.formType === 'edit-inline') {
                vm.createEditor()
                vm.editedGrapeContent = doc.data().grapeContent
                vm.setContentInterval = setInterval(vm.checkToLoadContent, 50)
              } else {
                vm.editedGrapeContent = doc.data().grapeContent
                vm.setContentInterval = setInterval(vm.checkToLoadContent, 50)
              }
            })
            // vm.getGrapeTags()
          })
        }
      },
      checkToLoadContent() {
        let vm = this
        if ($('#grape_editor').data('quill')) {
          $('#grape_editor').data('quill').clipboard.dangerouslyPasteHTML(vm.editedGrapeContent)
          clearInterval(vm.setContentInterval)
        } else {
          console.log('waiting to load content')
        }
      },
      getGrapeTags () {
        var vm = this
        if (this.isPress) {
          firebase.database().ref('proGrape_tags/' + vm.grapeID).once('value', function (snapshot) {
            if (snapshot.val() !== null) {
              vm.grapeTags = Object.keys(snapshot.val())
            }
            $('#grape_labels').tagit()
            if (vm.grapeTags) {
              for (var i = 0; i < vm.grapeTags.length; i++) {
                let tag = vm.grapeTags[i]
                $('#grape_labels').tagit('createTag', tag)
              }
            }
          })
        } else {
          firebase.database().ref('grape_tags/' + vm.grapeID).once('value', function (snapshot) {
            if (snapshot.val() !== null) {
              vm.grapeTags = Object.keys(snapshot.val())
            }
            $('#grape_labels').tagit()
            if (vm.grapeTags) {
              for (var i = 0; i < vm.grapeTags.length; i++) {
                let tag = vm.grapeTags[i]
                $('#grape_labels').tagit('createTag', tag)
              }
            }
          })
        }
      },
      getGrapeContent () {
        return $('#grape_content').val()
      },
      getGrapeLength () {
        var regex = /\s+/gi
        return $('#grape_content').val().trim().replace(regex, ' ').split(' ').length
      },
      validateGrape () {
        let grapeLength = this.getGrapeLength()
        // this.createShareModal()

        $('#grape_submit').prop('disabled', true)

        if (this.isPress) {
          if ((grapeLength < 100 || grapeLength > 550)) {
            this.submitNotice = 'Grape length is not valid - please check!'
          } else if ((grapeLength >= 100 && grapeLength <= 550) && (this.grapeSource !== '' && this.grapeTitle !== '')) {
            if (this.formType === 'new') {
              this.saveGrape()
            } else {
              this.updateGrape()
            }
          } else {
            this.submitNotice = 'URL, Title & Text are all required!'
          }
        } else {
          if (!this.sourceImage && this.grapeType == 'book') {
            this.submitNotice = 'Source must be selected and an image is required from the result!'
          } else if ((grapeLength < 100 || grapeLength > 550)) {
            this.submitNotice = 'Grape length is not valid - please check!'
          } else if (this.grapeTitle && this.grapeTitle.slice(0, 3) === 'on ') {
            this.submitNotice = 'As grapes appear as “x on y…”, please avoid “on” in the title field.'
          } else if (this.grapesFromBookCount > 10) {
            this.submitNotice = 'Unfortuantely at this time we are unable to accept any further grapes for this book.'
          } else if ((grapeLength >= 100 && grapeLength <= 550) && (this.grapeSourceTitle !== '' && this.grapeTitle !== '')) {
            this.submitNotice = ''
            if (this.formType === 'new') {
              this.saveGrape()
            } else {
              this.updateGrape()
            }
          } else if (this.grapeType == 'url') {
            if (this.grapeSource.indexOf('youtu') > -1) {
              this.submitNotice = ''
              if (this.formType === 'new') {
                this.saveGrape()
              } else {
                this.updateGrape()
              }
            } else {
              this.submitNotice = 'Only YouTube links are supported at this time.'
            }
          } else {
            this.submitNotice = 'Source, Title & Text are all required!'
          }
        }

        if (this.submitNotice != '') {
          setTimeout(function () {
            $('#grape_submit').prop('disabled', false)
          }, 2000)
        }
      },
      grapeLimitReached () {
        let vm = this
        let sourceTitle = vm.grapeSourceTitle
        let sourceID = vm.sourceID
        let routeData = this.$router.resolve({name: 'book', params: {title: encodeURI(sourceTitle), id: sourceID}})
        window.open(routeData.href, '_blank')
      },
      checkGrapeTitle () {
        let vm = this
        if (this.grapeTitle.length > 0) {
          let character = this.grapeTitle.charAt(0)
          if (vm.isLetter(character) && character === character.toUpperCase()) {
            vm.titleNotice = 'Note: Unless a proper noun, please avoid caps at the start of the title'
          } else {
            vm.titleNotice = ''
          }
        }
      },
      isLetter(str) {
        return str.length === 1 && str.match(/[a-z]/i);
      },
      saveGrape () {
        var vm = this
        var user = firebase.auth().currentUser
        const timestamp = firebase.firestore.FieldValue.serverTimestamp()

        if (this.isPress) {
          let grapeTitle = this.grapeTitle.replace(/\.$/, '')
          let publishYear = this.grapeOriginalPublishYear ? this.grapeOriginalPublishYear.replace(/\.$/, '') : ''
          var grapeSource = this.grapeSource
          var grapeAuthor = this.grapeSourceAuthor.replace(/\.$/, '')
          var random = crypto.randomBytes(4).readUInt32BE(0, true) + crypto.randomBytes(4).readUInt32BE(0, true)
          vm.grapeID = this.generateUUID()
          vm.grapeData = {
            grapeUserID: user.uid,
            grapeSource: grapeSource,
            sourceAuthor: grapeAuthor,
            grapeContent: this.getGrapeContent(),
            grapeLength: this.getGrapeLength(),
            grapeTitle: grapeTitle,
            grapeNotes: this.grapeNotes,
            grapePublication: this.grapePublication,
            grapeOriginalPublishYear: publishYear,
            grapeUsername: this.username,
            id: vm.grapeID,
            createdTimestamp: timestamp,
            updatedTimestamp: timestamp,
            random: random
          }

          var file = document.querySelector('#upload_source_image').files[0]
          if (file) {
            var ref = firebase.storage().ref();
            var name = (+new Date()) + '-' + file.name;
            var metadata = {
              contentType: file.type
            };
            var task = ref.child(name).put(file, metadata);
            task.then((snapshot) => {
              var url = snapshot.downloadURL;
              console.log(url);
              vm.grapeData.sourceImage = url
              vm.saveProGrape(vm.grapeData)
            }).catch((error) => {
              console.error(error);
            });
          } else {
            vm.saveProGrape(vm.grapeData)
          }
        } else {
          let title = this.grapeTitle
          let publishYear = this.grapeOriginalPublishYear ? this.grapeOriginalPublishYear.replace(/\.$/, '') : ''
          let translation = this.grapeTranslation ? this.grapeTranslation.replace(/\.$/, '') : ''
          var random = crypto.randomBytes(4).readUInt32BE(0, true) + crypto.randomBytes(4).readUInt32BE(0, true)
          var grapeSource = ''
          var grapeAuthor = ''
          if (this.grapeType == 'book') {
            grapeSource = this.grapeSourceTitle.replace(/\.$/, '')
            grapeAuthor = this.grapeSourceAuthor.replace(/\.$/, '')
          } else {
            grapeSource = this.grapeSource
            grapeAuthor = this.grapeSourceAuthor.replace(/\.$/, '')
          }
          vm.grapeID = this.generateUUID()
          vm.grapeData = {
            grapeUserID: user.uid,
            grapeType: this.grapeType,
            grapeSource: grapeSource,
            grapeContent: this.getGrapeContent(),
            grapeLength: this.getGrapeLength(),
            grapeTitle: title.replace(/\.$/, ''),
            grapeNotes: this.grapeNotes,
            grapeOriginalPublishYear: publishYear,
            grapeTranslation: translation,
            grapeUsername: this.username,
            sourceID: this.sourceID,
            sourceDescription: this.sourceDescription,
            sourceISBN: this.sourceISBN,
            sourceImage: this.sourceImage,
            sourceAuthor: grapeAuthor,
            sourceDate: this.sourceDate,
            id: vm.grapeID,
            createdTimestamp: timestamp,
            updatedTimestamp: timestamp,
            random: random
          }
          db.collection('grapes').add(vm.grapeData)
          .then(function (docRef) {
            console.log('Document written with ID: ', docRef.id)
            vm.createTagsDatabases()
            vm.grapeData.docID = docRef.id
            // vm.algoliaIndex(vm.grapeData)
            Router.push('/')
          })
          .catch(function (error) {
            console.error('Error adding document: ', error)
            setTimeout(function () {
              $('#grape_submit').prop('disabled', false)
            }, 2000)
          })
        }
      },
      saveProGrape (grapeData) {
        let vm = this
        db.collection('proGrapes').add(grapeData)
        .then(function (docRef) {
          console.log('Document written with ID: ', docRef.id)
          vm.createTagsDatabases()
          Router.push('/')
        })
        .catch(function (error) {
          console.error('Error adding document: ', error)
          setTimeout(function () {
            $('#grape_submit').prop('disabled', false)
          }, 2000)
        })
      },
      updateGrape () {
        console.log('trying to update grape')
        let vm = this
        const timestamp = firebase.firestore.FieldValue.serverTimestamp()

        if (this.isPress) {
          var grapeRef = db.collection('proGrapes').doc(vm.docID)
          let grapeTitle = this.grapeTitle.replace(/\.$/, '')
          let publishYear = this.grapeOriginalPublishYear ? this.grapeOriginalPublishYear.replace(/\.$/, '') : ''
          var grapeSource = this.grapeSource
          var grapeAuthor = this.grapeSourceAuthor.replace(/\.$/, '')
          vm.grapeID = this.generateUUID()
          vm.grapeData = {
            grapeSource: grapeSource,
            sourceAuthor: grapeAuthor,
            grapeContent: this.getGrapeContent(),
            grapeLength: this.getGrapeLength(),
            grapeTitle: grapeTitle,
            grapeNotes: this.grapeNotes,
            grapePublication: this.grapePublication,
            grapeOriginalPublishYear: publishYear,
            updatedTimestamp: timestamp
          }
          var file = document.querySelector('#upload_source_image').files[0]
          if (file) {
            var ref = firebase.storage().ref();
            var name = (+new Date()) + '-' + file.name;
            var metadata = {
              contentType: file.type
            };
            var task = ref.child(name).put(file, metadata);
            task.then((snapshot) => {
              var url = snapshot.downloadURL;
              console.log(url);
              vm.grapeData.sourceImage = url
              grapeRef.update(vm.grapeData)
              .then(function (docRef) {
                console.log('Document ' + vm.docID + ' successfully updated!')
                vm.grapeData.docID = vm.docID
                mixpanel.track(
                  'Grape updated through site form',
                  {
                    'docID': vm.docID
                  }
                )
                if (vm.formType === 'edit-inline') {
                  vm.$parent.inlineEditSaved()
                } else {
                  Router.push('/')
                }
              })
              .catch(function (error) {
                // The document probably doesn't exist.
                console.error('Error updating document: ', error)
              })
            }).catch((error) => {
              console.error(error);
            });
          } else {
            grapeRef.update(vm.grapeData)
            .then(function (docRef) {
              console.log('Document ' + vm.docID + ' successfully updated!')
              vm.grapeData.docID = vm.docID
              mixpanel.track(
                'Grape updated through site form',
                {
                  'docID': vm.docID
                }
              )
              if (vm.formType === 'edit-inline') {
                vm.$parent.inlineEditSaved()
              } else {
                Router.push('/')
              }
            })
            .catch(function (error) {
              // The document probably doesn't exist.
              console.error('Error updating document: ', error)
            })
          }
        } else {
          var grapeRef = db.collection('grapes').doc(vm.docID)
          let title = this.grapeTitle
          let publishYear = this.grapeOriginalPublishYear ? this.grapeOriginalPublishYear.replace(/\.$/, '') : ''
          let translation = this.grapeTranslation ? this.grapeTranslation.replace(/\.$/, '') : ''
          var grapeSource = ''
          var grapeAuthor = ''
          if (this.grapeType == 'book') {
            grapeSource = this.grapeSourceTitle.replace(/\.$/, '')
            grapeAuthor = this.grapeSourceAuthor.replace(/\.$/, '')
          } else {
            grapeSource = this.grapeSource
            grapeAuthor = this.grapeSourceAuthor.replace(/\.$/, '')
          }
          vm.grapeData = {
            grapeType: this.grapeType,
            grapeSource: grapeSource,
            grapeContent: this.getGrapeContent(),
            grapeLength: this.getGrapeLength(),
            grapeTitle: title.replace(/\.$/, ''),
            grapeNotes: this.grapeNotes,
            grapeOriginalPublishYear: publishYear,
            grapeTranslation: translation,
            sourceID: this.sourceID,
            sourceISBN: this.sourceISBN,
            sourceImage: this.sourceImage,
            sourceAuthor: grapeAuthor,
            sourceDate: this.sourceDate,
            updatedTimestamp: timestamp
          }
          grapeRef.update(vm.grapeData)
          .then(function (docRef) {
            console.log('Document ' + vm.docID + ' successfully updated!')
            vm.grapeData.docID = vm.docID
            mixpanel.track(
              'Grape updated through site form',
              {
                'docID': vm.docID
              }
            )
            if (vm.formType === 'edit-inline') {
              vm.$parent.inlineEditSaved()
            } else {
              Router.push('/')
            }
          })
          .catch(function (error) {
            // The document probably doesn't exist.
            console.error('Error updating document: ', error)
          })
        }
      },
      algoliaIndex (grape) {
        if (location.protocol === 'https:') {
          var client = algoliasearch('I3X2NRWKV7', '14d790560a425143a61099fd78bc9104')
          var index = client.initIndex('grapes')
          if (grape && grape.docID) {
            var grapeObject = grape
            grapeObject.objectID = grape.docID
            index.addObjects([grapeObject])
          }
        }
      },
      generateUUID () {
        let d = new Date().getTime()
        let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          let r = (d + Math.random() * 16) % 16 | 0
          d = Math.floor(d / 16)
          return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
        })
        return uuid
      },
      createEditor () {
        let vm = this
        let thisGrape = $('#grape-' + vm.grapeID)
        let thisGrapeID = '#grape-' + vm.grapeID

        var options = {
          modules: {
            toolbar: thisGrapeID + ' #toolbar'
          },
          placeholder: 'Add your grape...',
          readOnly: false,
          theme: 'snow'
        }
        var editor = new Quill(thisGrapeID + ' #grape_editor', options)
        thisGrape.find('#grape_editor').data('quill', editor)

        $('#omission-button').on('click', function () {
          var range = editor.getSelection()
          if (range) {
            editor.insertText(range.index, '+')
          }
        })

        $('#paragraph-remove-button').on('click', function () {
          var range = editor.getSelection()
          if (range) {
            editor.insertText(range.index, '<')
          }
        })

        $('#paragraph-insert-button').on('click', function () {
          var range = editor.getSelection()
          if (range) {
            editor.insertText(range.index, '>')
          }
        })

        function cleanUpWasteCodeText (textReplaced) {
          // for chrome bug. https://github.com/Alex-D/Trumbowyg/issues/103
          textReplaced = textReplaced.replace(/ style="[^"]*"/g, '')
          textReplaced = textReplaced.replace(/ ?face=[\d\D]* ?/g, '')
          textReplaced = textReplaced.replace(/ ?font-family:[\d\D]*; ?/g, '')
          textReplaced = textReplaced.replace(/ ?font-family:[\d\D]*; ?/g, '')
          textReplaced = textReplaced.replace(/ ?font-size:[\d\D]*; ?/g, '')
          textReplaced = textReplaced.replace(/ ?font-weight:[\d\D]*; ?/g, '')
          textReplaced = textReplaced.replace(/ ?line-height:[\d\D]*; ?/g, '')
          textReplaced = textReplaced.replace(/ ?background-color:[\d\D]*; ?/g, '')
          textReplaced = textReplaced.replace(/ ?color:[\d\D]*; ?/g, '')

          textReplaced = textReplaced.replace(/ ?id="null" ?/g, '')
          textReplaced = textReplaced.replace(/ ?text-align: left; ?/g, '')
          textReplaced = textReplaced.replace(/<>/g, '')
          return textReplaced
        }

        function cleanUpWasteCode ($textarea) {
          var textReplaced = $textarea.val()
          textReplaced = cleanUpWasteCodeText(textReplaced)
          $textarea.val(textReplaced)
        }

        editor.on('text-change', grapeContentUpdate)

        function grapeContentUpdate (delta) {
          var contents = jQuery('#grape_editor').find('.ql-editor').html()
          $('#grape_content').val(contents)
          cleanUpWasteCode(jQuery('#grape_content'))
          getGrapeLength()
           if ($('.grape-form-wrap').data('form-type') !== 'edit-inline') {
            jQuery('#grape_editor').tooltip('close')
          }
        }

        function getGrapeLength () {
          var text = editor.getText()
          text = text.trim()
          let length = text.length > 0 ? text.split(/\s+/).length : 0
          $('.grape-form-wrap .word-count > span').html(length)
          if (length < 100 || length > 550) {
            $('.word-count').addClass('warning')
          } else {
            $('.word-count').removeClass('warning')
          }
          if (length > 0) {
            $('.delete-text-button').css('display', 'inline-block')
          } else {
            $('.delete-text-button').css('display', 'none')
          }
        }

        if (vm.editedGrapeContent) {
          $('#grape_editor').data('quill').clipboard.dangerouslyPasteHTML(vm.editedGrapeContent)
        }
      },
      createTagsDatabases () {
        let vm = this
        // vm.tags = this.getTags()
        // for (var i = 0; i < vm.tags.length; i++) {
        //   if (vm.isPress) {
        //     let tag = vm.tags[i]
        //     firebase.database().ref('proTags').child(tag).once('value', function (snapshot) {
        //       var exists = (snapshot.val() !== null)
        //       vm.tagExistsCallback(tag, exists, snapshot.val())
        //     })
        //     let grapeTagData = {}
        //     grapeTagData[tag] = 0
        //     firebase.database().ref('proGrape_tags/' + vm.grapeID).update(grapeTagData)            
        //   } else {
        //     let tag = vm.tags[i]
        //     firebase.database().ref('tags').child(tag).once('value', function (snapshot) {
        //       var exists = (snapshot.val() !== null)
        //       vm.tagExistsCallback(tag, exists, snapshot.val())
        //     })
        //     let grapeTagData = {}
        //     grapeTagData[tag] = 0
        //     firebase.database().ref('grape_tags/' + vm.grapeID).update(grapeTagData)            
        //   }
        // }
      },
      tagExistsCallback (tag, exists, val) {
        console.log(tag)
        let vm = this
        if (vm.isPress) {
          if (exists) {
            let data = val.grapes
            data.push(vm.grapeID)
            firebase.database().ref('proTags/' + tag).set({
              grapes: data
            })
          } else {
            firebase.database().ref('proTags/' + tag).set({
              grapes: [vm.grapeID]
            })
          }
        } else {
          if (exists) {
            let data = val.grapes
            data.push(vm.grapeID)
            firebase.database().ref('tags/' + tag).set({
              grapes: data
            })
          } else {
            firebase.database().ref('tags/' + tag).set({
              grapes: [vm.grapeID]
            })
          }
        }
      },
      getTags () {
        return $('#grape_labels').tagit('assignedTags')
      },
      getGrapeLength () {
        var grapeEditor = $('#grape_editor').data('quill')
        var text = grapeEditor.getText()
        text = text.trim()
        return text.length > 0 ? text.split(/\s+/).length : 0
      },
      cancelUpdateGrape () {
        this.$parent.inlineEditCancelled()
      },
      getBooks () {
        if (this.grapeType == 'url') {
          return
        }
        console.log('get books')
        let vm = this
        let sourceTitle = vm.grapeSourceTitle
        let sourceAuthor = vm.grapeSourceAuthor
        var booksUrl = 'https://www.googleapis.com/books/v1/volumes?printType=books&q=intitle:' + encodeURIComponent(sourceTitle) + '&key=AIzaSyCY-NWXsPHxw-mV_ATX2qdycXSbxtK1zVM'

        if (sourceTitle !== '' && sourceAuthor !== '') {
          booksUrl = 'https://www.googleapis.com/books/v1/volumes?printType=books&q=intitle:' + encodeURIComponent(sourceTitle) + '+inauthor:' + encodeURIComponent(sourceAuthor) + '&key=AIzaSyCY-NWXsPHxw-mV_ATX2qdycXSbxtK1zVM'
        } else if (sourceTitle === '' && sourceAuthor !== '') {
          booksUrl = 'https://www.googleapis.com/books/v1/volumes?printType=books&q=inauthor:' + encodeURIComponent(sourceAuthor) + '&key=AIzaSyCY-NWXsPHxw-mV_ATX2qdycXSbxtK1zVM'
        }

        console.log(booksUrl)
        $.ajax({
          url: booksUrl,
          success: function (data) {
            // Clear existing array
            vm.bookResults = []

            $('#books-table > tbody').empty()
            if (data.items) {
              var noISBNbooks = []
              var len = data.items.length

              // sort the books
              for (var i = 0; i < len; i++) {
                console.log(i)
                var item = data.items[i]
                /* remove if no isbn */
                if (!item) {
                  continue
                }
                console.log(item.id)
                if (item.volumeInfo.industryIdentifiers) {
                  var ISBNs = item.volumeInfo.industryIdentifiers
                  var ISBN13 = ''
                  var ISBN10 = ''
                  for (var j = 0; j < ISBNs.length; j++) {
                    var thisISBN = ISBNs[j]
                    if (thisISBN.type === 'ISBN_13') {
                      ISBN13 = thisISBN.identifier
                    } else if (thisISBN.type === 'ISBN_10') {
                      ISBN10 = thisISBN.identifier
                    }
                  }
                  console.log(item.volumeInfo.title + ', ISBN13: ' + ISBN13 + ', ISBN10: ' + ISBN10)
                  if (ISBN13 === '' && ISBN10 === '') {
                    console.log(item.volumeInfo.title + ' no isbn13 or 10, moving to end')
                    noISBNbooks.push(item)
                    continue
                  }
                } else {
                  console.log(item.volumeInfo.title + ' no isbn data, moving to end')
                  noISBNbooks.push(item)
                  continue
                }
                /* remove if no image */
                if (item.volumeInfo.imageLinks == null) {
                  console.log(item.volumeInfo.title + ' no image links')
                  continue
                }

                // If all OK, add this item to final results
                vm.bookResults.push(item)
              }

              // contat arrays
              vm.bookResults = vm.bookResults.reverse()
              vm.bookResults = vm.bookResults.concat(noISBNbooks)

              // output the table
              for (var i = 0; i < vm.bookResults.length; i++) {
                var book = vm.bookResults[i]
                let title = book.volumeInfo.title
                let image = book.volumeInfo.imageLinks == null ? '' : book.volumeInfo.imageLinks.thumbnail
                let author = book.volumeInfo.authors == null ? '' : book.volumeInfo.authors
                var year = book.volumeInfo.publishedDate == null ? '' : book.volumeInfo.publishedDate

                if (year && year.length > 4) {
                  year = year.substring(0, 4)
                }
                $('#books-table > tbody').append('<tr data-key="' + i + '"><td class="image"><img src="' + image + '" alt="' + title + '" /></td><td class="title">' + title + '</td><td class="author">' + author + '</td><td class="year">' + year + '</td></tr>')
              }
              var $window = $(window)
              if ($window.width() < 768) {
                $('.mobile-source-preview-wrap').css('display', 'block')
              } else {
                $('.desktop-source-preview-wrap').css('display', 'block')
              }
            }
          }
        })
      },
      checkExistingGrapes (sourceID) {
        var vm = this
        var grapesRef = db.collection('grapes').where('sourceID', '==', sourceID)
        vm.grapesFromBookCount = 0
        grapesRef.get().then((querySnapshot) => {
          vm.grapesFromBookCount = querySnapshot.docs.length
          console.log('grapesFromBookCount: ' + vm.grapesFromBookCount + ' for sourceID: ' + sourceID)
          if (vm.grapesFromBookCount >= 10) {
            if (location.protocol === 'https:') {
              var client = algoliasearch('I3X2NRWKV7', '14d790560a425143a61099fd78bc9104')
              var uploadsIndex = client.initIndex('BookGrapeLimits')
              var dt = new Date()
              uploadsIndex.addObjects([{
                userID: $('#user_id').val(),
                username: $('#username').val(),
                bookTitle: $('#grape_source_title').val(),
                bookAuthor: $('#grape_source_author').val(),
                grapesFromBookCount: vm.grapesFromBookCount,
                timestamp: dt
              }])
            }
          }
        })
      }
    },
    mounted () {
      let $vue = this;

      // trigger2 function
      (function ($) {
        setTimeout(function() {
          if ($vue.formType === 'new') {
            // new grape form
            $vue.createEditor()
          } else if ($vue.formType === 'edit-direct') {
            $vue.createEditor()
          }
        }, 1000)


        $.fn.trigger2 = function (eventName) {
          return this.each(function () {
            var el = $(this).get(0)
            triggerNativeEvent(el, eventName)
          })
        }

        function triggerNativeEvent (el, eventName) {
          if (el.fireEvent) { // < IE9
            (el.fireEvent('on' + eventName))
          } else {
            var evt = document.createEvent('Events')
            evt.initEvent(eventName, true, false)
            el.dispatchEvent(evt)
          }
        }
      }(jQuery))

      /**********************************************
      ***
      *** Tooltip
      ***
      **********************************************/
      if ($('.grape-form-wrap').data('form-type') !== 'edit-inline') {
        $('.tooltip,.editor-tooltip').tooltip({
          items: '[title]',
          position: { my: 'left top+5', at: 'left bottom', collision: 'flipfit' },
          content: function() {
            var element = $(this)
            if (element.is('[title]')) {
              return element.attr('title')
            }
          }
        })
      }

      $('.tooltip').on('keyup', function () {
        if ($('.grape-form-wrap').data('form-type') !== 'edit-inline') {
          $(this).tooltip('close')
        }
      })

      /**********************************************
      ***
      *** Book select
      ***
      **********************************************/
      var timeout = null
      $('#grape_source_title,#grape_source_author').on('keyup', function () {
        if ($('#grape_type').val() !== 'book') {
          return
        }
        if ($('#grape_source_title').val().length < 3 && $('#grape_source_author').val().length < 3) {
          return
        }
        clearTimeout(timeout)
        timeout = setTimeout(function () {
          $vue.getBooks()
        }, 500)
      })
      $('#books-table').on('click', 'tr', function () {
        console.log($vue.bookResults[$(this).data('key')])
        $('.source-preview-wrap').addClass('book-selected')
        processBookData($vue.bookResults[$(this).data('key')])
      })
      $('.source-preview-back').on('click', '', function () {
        $('.source-preview-wrap').removeClass('book-selected')
        return false
      })

      /**********************************************
      ***
      *** Process Book Data
      ***
      **********************************************/
      function processBookData (book) {
        book.image = book.volumeInfo.imageLinks == null ? '' : book.volumeInfo.imageLinks.thumbnail
        book.author = book.volumeInfo.authors == null ? '' : book.volumeInfo.authors

        // Update stored values and trigger vue
        $('#grape_source').autocomplete('disable')
        $('#grape_source').val(book.volumeInfo.title).trigger2('input')
        $('#grape_source').autocomplete('enable')
        $('#source_id').val(book.id).trigger2('input')
        $('#grape_source_title').val(book.volumeInfo.title).trigger2('input')
        $('#grape_source_author').val(book.author).trigger2('input')
        $vue.checkExistingGrapes(book.id)

        if (book.image !== '') {
          $('#source_image').val(book.image).trigger2('input')
        }
        if (book.volumeInfo.industryIdentifiers) {
          var ISBNs = book.volumeInfo.industryIdentifiers
          var ISBNFinal = ''
          var ISBN13 = ''
          var ISBN10 = ''
          var ISBNOther = ''
          for (var j = 0; j < ISBNs.length; j++) {
            var thisISBN = ISBNs[j]
            if (thisISBN.type === 'ISBN_13') {
              ISBN13 = thisISBN.identifier
            } else if (thisISBN.type === 'ISBN_10') {
              ISBN10 = thisISBN.identifier
            } else {
              // ISBNOther = thisISBN.identifier
              ISBNOther = ''
            }
          }
          if (ISBN13 !== '') {
            ISBNFinal = ISBN13
          } else if (ISBN10 !== '') {
            ISBNFinal = ISBN10
          } else {
            ISBNFinal = ISBNOther
          }
          $('#source_isbn').val(ISBNFinal).trigger2('input')
        }
        $('#source_description').val(book.volumeInfo.description).trigger2('input')
        $('#source_author').val(book.author).trigger2('input')
        $('#source_date').val(book.volumeInfo.publishedDate).trigger2('input')

        // first clear anything that may already be in the description
        $('#source-preview').empty()

        // we get the currently selected item using ui.item
        // show a pic if we have one
        if (book.image !== '') {
          $('#source-preview').append('<img src="' + book.image + '" style="float: left; padding: 0 20px 20px 0;">')
        }
        // and title, author, and year
        $('#source-preview').append('<p class="first-line"><b>Title:</b> ' + book.volumeInfo.title + '</p>')
        if (book.author) {
          $('#source-preview').append('<p><b>Author:</b> ' + book.author + '</p>')
        }
        $('#source-preview').append('<p><b>First published:</b> ' + book.volumeInfo.publishedDate + '</p>')
        // and the usual description of the book
        if (book.volumeInfo.description) {
          var description = book.volumeInfo.description
          if (description && description.length >= 100) {
            description = description.substring(0, 100) + '...'
          }
          $('#source-preview').append('<p><b>Description:</b> ' + description + '</p>')
        }
        // and show the link to oclc (if we have an isbn number)
        if (ISBNFinal) {
          $('#source-preview').append('<p class="last-line"><b>ISBN:</b> ' + ISBNFinal + '<a href="http://www.worldcat.org/isbn/' + ISBNFinal + '" target="_blank">View item on worldcat</a></p>')
        }
      }

      /**********************************************
      ***
      *** Upload scan trigger
      ***
      **********************************************/
      var uploadedFiles = []
      var removedFiles = []
      var $processedText = ''
      var ajaxQueueStamp = Math.random().toString(36).substr(2, 10)
      var totalFiles = 0

      jQuery('#upload_scan').on('change', function (e) {
        $('body').addClass('pace-running')
        $('.pace').addClass('pace-active')
        $('.pace-opt').addClass('show-opt')
        var files = e.target.files;
        [].forEach.call(files, function(file) {
          console.log(file)
          if (!checkImageRemoved(removedFiles, file.name, file.size, true)) {
            uploadedFiles.push(file); // Simplest case
          }
        });
        console.log(uploadedFiles)
        console.log(removedFiles)
        totalFiles = uploadedFiles.length
        $('#selected-image-wrap > .images').sortable({
          forcePlaceholderSize: true,
          placeholder: 'ui-state-highlight',
          update: function (event, ui) {
            var $lis = $(this).children('div')
            $lis.each(function () {
              var $li = $(this)
              var newVal = $li.index()
              $li.children('span').html(newVal)
            })
          }
        })
        for (var i = 0; i < uploadedFiles.length; i++) {
          var $this = uploadedFiles[i]
          $this.id = i
        }
        uploadedFiles.sort(function (a, b) {
          if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
            var countA = a.id ? parseInt(a.id) : 0
            var countB = b.id ? parseInt(b.id) : 0
            return countA - countB
          } else {
            var textA = a.name.toUpperCase()
            var textB = b.name.toUpperCase()
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
          }
        })
        for (var i = 0; i < uploadedFiles.length; i++) {
          var $this = uploadedFiles[i]
          processOCR(ajaxQueueStamp, $this, $this.name)
        }
        setTimeout(function () {
          if (totalFiles > 0) {
            $('.reupload-button').css('display', 'block')
          }
          handleUploadedFiles(uploadedFiles)
        }, 500)
      })

      jQuery(document).on('click', '.delete-text-button', function (e) {
        e.preventDefault()
        var retVal = confirm('Are you sure you want to delete the text?')
        if (retVal === true) {
          var grapeEditor = $('#grape_editor').data('quill')
          grapeEditor.setText('')
          $processedText = ''
        }
      })

      jQuery(document).on('click', '.reupload-button', function (e) {
        e.preventDefault()
        $('body').addClass('pace-running')
        $('.pace').addClass('pace-active')
        $('.pace-opt').addClass('show-opt')
        $processedText = ''
        ajaxQueueStamp = Math.random().toString(36).substr(2, 10)
        var sortedIDs = $('#selected-image-wrap > .images').sortable('toArray')
        totalFiles = uploadedFiles.length
        console.log(totalFiles)
        console.log('sortedIDs:' + sortedIDs.length)
        for (var i = 0; i < sortedIDs.length; i++) {
          var $this = sortedIDs[i]
          var thisObject = findUploadedFile($this, uploadedFiles)
          if (thisObject) {
            processOCR(ajaxQueueStamp, thisObject, thisObject.name)
          }
        }
      })

      function checkImageRemoved (inArr, name, size, exists) {
        for (var i = 0; i < inArr.length; i++) {
          if (inArr[i].name === name && inArr[i].size === size) {
            return (exists === true) ? true : inArr[i]
          }
        }
      }

      function handleUploadedFiles (files) {
        $('#selected-image-wrap > .images').empty()
        // Loop through the FileList and render image files as thumbnails.
        for (var i = 0; i < files.length; i++) {
          var f = files[i]
          console.log(f)
          handleImage(f, f.name)
        }
        var $window = $(window)
        if ($window.width() < 768) {
          $('.mobile-source-preview-wrap').css('display', 'block')
        } else {
          $('.desktop-source-preview-wrap').css('display', 'block')
        }
      }

      function findUploadedFile (nameKey, myArray) {
        for (var i = 0; i < myArray.length; i++) {
          if (myArray[i].name === nameKey) {
            return myArray[i]
          }
        }
      }

      function handleImage (f, i) {
        var canvas = document.createElement('canvas')
        if (canvas.toBlob) {
          new ImageCompressor(f, {
            quality: 0.6,
            success (result) {
              console.log(result)
              var div = document.createElement('div')
              var span = document.createElement('span')
              var a = document.createElement('a')
              var img = document.createElement('img')
              img.onload = function (e) {
                window.URL.revokeObjectURL(img.src) // Clean up after yourself.
              }
              img.src = window.URL.createObjectURL(result)
              img.style.maxWidth = '100%'
              img.style.height = 'auto'
              img.style.display = 'block'
              a.href = '#'
              a.classList.add('remove-image')
              div.style.float = 'left'
              div.style.width = '100%'
              div.style.marginBottom = '20px'
              div.style.overflow = 'hidden'
              div.id = i
              div.append(img)
              div.append(span)
              div.append(a)
              $('#selected-image-wrap > .images').append(div)
              $('#selected-image-wrap > .images').sortable('refresh')
              sortFiles()
            }
          })
        } else {
          var div = document.createElement('div')
          var span = document.createElement('span')
          var a = document.createElement('a')
          var img = document.createElement('img')
          img.onload = function (e) {
            window.URL.revokeObjectURL(img.src) // Clean up after yourself.
          }
          img.src = window.URL.createObjectURL(f)
          img.style.maxWidth = '100%'
          img.style.height = 'auto'
          img.style.display = 'block'
          a.href = '#'
          a.classList.add('remove-image')
          div.style.float = 'left'
          div.style.width = '100%'
          div.style.marginBottom = '20px'
          div.style.overflow = 'hidden'
          div.id = 'image-' + i
          div.append(img)
          div.append(span)
          div.append(a)
          $('#selected-image-wrap > .images').append(div)
          $('#selected-image-wrap > .images').sortable('refresh')
          sortFiles()
        }
      }

      function sortFiles () {
        var sortableList = $('#selected-image-wrap > .images')
        var listitems = $('div', sortableList)
        listitems.sort(function (a, b) {
          return ($(a).attr('id').toUpperCase() > $(b).attr('id').toUpperCase()) ? 1 : -1
        })
        sortableList.append(listitems)
      }

      $(document).on('click', '.cancel-ajax-ocr', function () {
        $.ajaxq.abort(ajaxQueueStamp)
        $('body').removeClass('pace-running')
        $('.pace').removeClass('pace-active')
        $('.pace-opt').removeClass('show-opt')
        return false
      })

      $(document).on('click', 'a.remove-image', function() {
        var $thisImage = $(this).parent(),
            $index = $thisImage.index();

        removedFiles.push(uploadedFiles[$index])
        uploadedFiles.splice($index,1)
        totalFiles = uploadedFiles.length
        $thisImage.remove()

        return false;
      })


      /**********************************************
      ***
      *** Process OCR API
      ***
      **********************************************/
      function processOCR (qname, $image, $imageName) {
        // Prepare form data
        var formData = new FormData()
        if ($imageName !== '') {
          formData.append('file', $image, $imageName)
        } else {
          formData.append('file', $image)
        }
        formData.append('language', 'eng')
        formData.append('apikey', 'PKMXB5887888A')
        formData.append('isOverlayRequired', true)
        var startOCR = new Date()
        // Send OCR Parsing request asynchronously
        jQuery.ajaxq(qname, {
          url: 'https://api.ocr.space/parse/image',
          data: formData,
          dataType: 'json',
          cache: false,
          contentType: false,
          processData: false,
          type: 'POST',
          async: true,
          success: function (ocrParsedResult) {
            // Get the parsed results, exit code and error message and details
            var parsedResults = ocrParsedResult['ParsedResults']
            // If we have got parsed results, then loop over the results to do something
            if (parsedResults != null) {
              // Loop through the parsed results
              $.each(parsedResults, function (index, value) {
                console.log(parsedResults)
                var exitCode = value['FileParseExitCode']
                var parsedText = value['ParsedText']
                var errorMessage = value['ParsedTextFileName']
                var textOverlay = value['TextOverlay']
                var pageText = ''
                switch (+exitCode) {
                  case 1:
                    parsedText = parsedText.replace(/- /g, '')
                    pageText = parsedText
                    break
                  case 0:
                  case -10:
                  case -20:
                  case -30:
                  case -99:
                  default:
                    pageText += 'Error: ' + errorMessage
                    break
                }

                $.each(textOverlay['Lines'], function (index, value) {
                  // LOOP THROUGH THE LINES AND GET WORDS TO DISPLAY ON TOP OF THE IMAGE AS OVERLAY
                })

                // our code here
                var endOCR = new Date()
                var ocrProcessDuration = endOCR - startOCR
                if (location.protocol === 'https:') {
                  var client = algoliasearch('I3X2NRWKV7', '14d790560a425143a61099fd78bc9104')
                  var uploadsIndex = client.initIndex('OCRUploads')
                  var fsize = $image.size
                  var dt = new Date()
                  uploadsIndex.addObjects([{
                    userID: $('#user_id').val(),
                    username: $('#username').val(),
                    ocrProcessTime: ocrParsedResult.ProcessingTimeInMilliseconds,
                    duration: ocrProcessDuration,
                    text: pageText,
                    timestamp: dt,
                    filesize: fsize
                  }])
                }
                pageText = pageText.replace(/\r?\n|\r/g, '')
                pageText = pageText.replace(/- /g, '')
                $processedText = $processedText + pageText
                $processedText = cleanUpWasteCodeText($processedText)
                var grapeEditor = $('#grape_editor').data('quill')
                grapeEditor.setText($processedText)
                getGrapeLength()
                console.log('processOCR done, totalFiles: ' + totalFiles)
                if (totalFiles <= 1) {
                  $('body').removeClass('pace-running')
                  $('.pace').removeClass('pace-active')
                  $('.pace-opt').removeClass('show-opt')
                }
                totalFiles--
              })
            }
          }
        })
      }

      /**********************************************
      ***
      *** Function to remove styling from grape
      ***
      **********************************************/
      function cleanUpWasteCodeText (textReplaced) {
        // for chrome bug. https://github.com/Alex-D/Trumbowyg/issues/103
        textReplaced = textReplaced.replace(/ style="[^"]*"/g, '')
        textReplaced = textReplaced.replace(/ ?face=[\d\D]* ?/g, '')
        textReplaced = textReplaced.replace(/ ?font-family:[\d\D]*; ?/g, '')
        textReplaced = textReplaced.replace(/ ?font-family:[\d\D]*; ?/g, '')
        textReplaced = textReplaced.replace(/ ?font-size:[\d\D]*; ?/g, '')
        textReplaced = textReplaced.replace(/ ?font-weight:[\d\D]*; ?/g, '')
        textReplaced = textReplaced.replace(/ ?line-height:[\d\D]*; ?/g, '')
        textReplaced = textReplaced.replace(/ ?background-color:[\d\D]*; ?/g, '')
        textReplaced = textReplaced.replace(/ ?color:[\d\D]*; ?/g, '')

        textReplaced = textReplaced.replace(/ ?id="null" ?/g, '')
        textReplaced = textReplaced.replace(/ ?text-align: left; ?/g, '')
        textReplaced = textReplaced.replace(/<>/g, '')
        return textReplaced
      }

      function getGrapeLength () {
        var grapeEditor = $('#grape_editor').data('quill')
        var text = grapeEditor.getText()
        text = text.trim()
        let length = text.length > 0 ? text.split(/\s+/).length : 0
        $('.grape-form-wrap .word-count > span').html(length)
        if (length < 100 || length > 550) {
          $('.word-count').addClass('warning')
        } else {
          $('.word-count').removeClass('warning')
        }
      }

      /**********************************************
      ***
      *** Tags functionality
      ***
      **********************************************/
      // $('#grape_labels').tagit({
      //   allowSpaces: true
      // })

      /**********************************************
      ***
      *** Adjust autocomplete state
      ***
      **********************************************/
      $('#grape_type').on('change', function () {
        var $type = $(this).val()

        $('#source-preview').empty().css('display', 'none')
        $('.mobile-source-preview-wrap').css('display', 'none')
        $('.desktop-source-preview-wrap').css('display', 'none')

        // if ($type === 'book') {
        //   $('#grape_source').autocomplete('enable')
        // } else {
        //   $('#grape_source').autocomplete('disable')
        // }
      })

      /**********************************************
      ***
      *** Source autocomplete
      ***
      **********************************************/
      $('#grape_source').autocomplete({
        // define source of the data
        source: function (request, response) {
          // url link to google books, including text entered by user (request.term)
          var booksUrl = 'https://www.googleapis.com/books/v1/volumes?printType=books&q=intitle:"' + encodeURIComponent(request.term) + '"&orderBy=newest&key=AIzaSyCY-NWXsPHxw-mV_ATX2qdycXSbxtK1zVM'
          $.ajax({
            url: booksUrl,
            dataType: 'jsonp',
            success: function (data) {
              if (data.items) {
                for (var i = 0; i < data.items.length; i++) {
                  var item = data.items[i]
                  console.log(item)
                  /* remove if no isbn */
                  if (item.volumeInfo.industryIdentifiers) {
                    var ISBNs = item.volumeInfo.industryIdentifiers
                    var ISBN13 = ''
                    var ISBN10 = ''
                    for (var j = 0; j < ISBNs.length; j++) {
                      var thisISBN = ISBNs[j]
                      if (thisISBN.type === 'ISBN_13') {
                        ISBN13 = thisISBN.identifier
                      } else if (thisISBN.type === 'ISBN_10') {
                        ISBN10 = thisISBN.identifier
                      }
                    }
                    if (ISBN13 === '' && ISBN10 === '') {
                      console.log('no isbn13 or 10, removing')
                      data.items.splice(i, 1)
                      continue
                    }
                  } else {
                    console.log('no isbn data, removing')
                    data.items.splice(i, 1)
                    continue
                  }
                  /* remove if no image */
                  if (item.volumeInfo.imageLinks == null) {
                    console.log('no image links')
                    data.items.splice(i, 1)
                    continue
                  }
                }
              }
              response($.map(data.items, function (item) {
                if (item.volumeInfo.authors && item.volumeInfo.title && item.volumeInfo.industryIdentifiers && item.volumeInfo.publishedDate) {
                  return {
                    // label value will be shown in the suggestions
                    label: item.volumeInfo.title + ', ' + item.volumeInfo.authors[0] + ', ' + item.volumeInfo.publishedDate,
                    // value is what gets put in the textbox once an item selected
                    value: item.volumeInfo.title,
                    // other individual values to use later
                    title: item.volumeInfo.title,
                    author: item.volumeInfo.authors,
                    isbn: item.volumeInfo.industryIdentifiers,
                    publishedDate: item.volumeInfo.publishedDate,
                    image: (item.volumeInfo.imageLinks == null ? '' : item.volumeInfo.imageLinks.thumbnail),
                    description: item.volumeInfo.description,
                    date: item.volumeInfo.publishedDate,
                    id: item.id
                  }
                }
              }))
            }
          })
        },
        select: function (event, ui) {
          // Update stored values and trigger vue
          $('#grape_source').autocomplete('disable')
          $('#grape_source').val(ui.item.title).trigger2('input')
          $('#grape_source').autocomplete('enable')

          $('#source_id').val(ui.item.id).trigger2('input')
          if (ui.item.image !== '') {
            $('#source_image').val(ui.item.image).trigger2('input')
          }
          if (ui.item.isbn) {
            var ISBNs = ui.item.isbn
            var ISBNFinal = '', ISBN13 = '', ISBN10 = '', ISBNOther = ''
            for (var j = 0; j < ISBNs.length; j++) {
              var thisISBN = ISBNs[j]
              if (thisISBN.type === 'ISBN_13') {
                ISBN13 = thisISBN.identifier
              } else if (thisISBN.type === 'ISBN_10') {
                ISBN10 = thisISBN.identifier
              } else {
                // ISBNOther = thisISBN.identifier
                ISBNOther = ''
              }
            }
            if (ISBN13 !== '') {
              ISBNFinal = ISBN13
            } else if (ISBN10 !== '') {
              ISBNFinal = ISBN10
            } else {
              ISBNFinal = ISBNOther
            }
            $('#source_isbn').val(ISBNFinal).trigger2('input')
          }
          $('#source_description').val(ui.item.description).trigger2('input')
          $('#source_author').val(ui.item.author).trigger2('input')
          $('#source_date').val(ui.item.date).trigger2('input')

          // first clear anything that may already be in the description
          $('#source-preview').empty()

          // we get the currently selected item using ui.item
          // show a pic if we have one
          if (ui.item.image !== '') {
            $('#source-preview').append('<img src="' + ui.item.image + '" style="float: left; padding: 0 20px 20px 0;">')
          }
          // and title, author, and year
          $('#source-preview').append('<p class="first-line"><b>Title:</b> ' + ui.item.title + '</p>')
          $('#source-preview').append('<p><b>Author:</b> ' + ui.item.author + '</p>')
          $('#source-preview').append('<p><b>First published year:</b> ' + ui.item.publishedDate + '</p>')
          // and the usual description of the book
          var description = ui.item.description
          if (description && description.length >= 100) {
            description = description.substring(0, 100) + '...'
          }
          $('#source-preview').append('<p><b>Description:</b> ' + description + '</p>')
          // and show the link to oclc (if we have an isbn number)
          if (ui.item.isbn && ui.item.isbn[0].identifier) {
            $('#source-preview').append('<P><b>ISBN:</b> ' + ui.item.isbn[0].identifier + '</p>')
            $('#source-preview').append('<a href="http://www.worldcat.org/isbn/' + ui.item.isbn[0].identifier + '" target="_blank">View item on worldcat</a>')
          }
        },
        minLength: 2 // set minimum length of text the user must enter
      })

      /**********************************************
      ***
      *** Book/Table preview handling
      ***
      **********************************************/
      function onResize (c, t){ onresize = function (){ clearTimeout(t); t = setTimeout(c, 100) }; return c }
      function checkResultsPlacement () {
        var $window = $(window)
        console.log($window.width())
        if ($window.width() < 768 && $('.source-preview-wrap').closest('.source-preview-inner').length >= 0) {
          console.log('moving source preview to mobile')
          $('.source-preview-inner').appendTo('.mobile-source-preview-wrap')
          if ($('.desktop-source-preview-wrap').is(':visible')) {
            $('.mobile-source-preview-wrap').css('display', 'block')
            $('.desktop-source-preview-wrap').css('display', 'none')
          }
        } else if ($window.width() >= 768 && $('.mobile-source-preview-wrap').closest('.source-preview-inner').length >= 0) {
          console.log('moving source preview to desktop')
          $('.source-preview-inner').appendTo('.desktop-source-preview-wrap')
          if ($('.mobile-source-preview-wrap').is(':visible')) {
            $('.mobile-source-preview-wrap').css('display', 'none')
            $('.desktop-source-preview-wrap').css('display', 'block')
          }
        }
      }
      checkResultsPlacement()
      onResize(function () {
        checkResultsPlacement()
      })

      /**********************************************
      ***
      *** Video source handling
      ***
      **********************************************/

      $(document).on('input', '#grape_source', function () {
        var videoURL = $(this).val()
        var urlCheck = parseVideo(videoURL)

        if (urlCheck.type === 'youtube' || urlCheck.type === 'vimeo') {
          var video = createVideo(videoURL, 500, 300)
          console.log('get video thumb')
          getVideoThumbnail(videoURL, function ($image) {
            console.log($image)
            $('#source_image').val($image).trigger2('input')
          })
          $('#source-preview').empty()
          $('#source-preview').append(video).css('display', 'block')
          var $window = $(window)
          if ($window.width() < 768) {
            $('.mobile-source-preview-wrap').css('display', 'block')
          } else {
            $('.desktop-source-preview-wrap').css('display', 'block')
          }
        }
      })

      function parseVideo (url) {
        // - Supported YouTube URL formats:
        //   - http://www.youtube.com/watch?v=My2FRPA3Gf8
        //   - http://youtu.be/My2FRPA3Gf8
        //   - https://youtube.googleapis.com/v/My2FRPA3Gf8
        // - Supported Vimeo URL formats:
        //   - http://vimeo.com/25451551
        //   - http://player.vimeo.com/video/25451551
        // - Also supports relative URLs:
        //   - //player.vimeo.com/video/25451551

        // url.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/)
        url.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\S+)?/)

        var type = ''
        if (RegExp.$3.indexOf('youtu') > -1) {
          type = 'youtube'
        } else if (RegExp.$3.indexOf('vimeo') > -1) {
          type = 'vimeo'
        }

        return {
          type: type,
          id: RegExp.$6
        }
      }

      function createVideo (url, width, height) {
        // Returns an iframe of the video with the specified URL.
        var videoObj = parseVideo(url)
        var $iframe = $('<iframe>', { width: width, height: height })
        $iframe.attr('frameborder', 0)
        if (videoObj.type === 'youtube') {
          $iframe.attr('src', '//www.youtube.com/embed/' + videoObj.id)
        } else if (videoObj.type === 'vimeo') {
          $iframe.attr('src', '//player.vimeo.com/video/' + videoObj.id)
        }
        return $iframe
      }

      function getVideoThumbnail (url, cb) {
        // Obtains the video's thumbnail and passed it back to a callback function.
        var videoObj = parseVideo(url)
        if (videoObj.type === 'youtube') {
          var imageURL = '//img.youtube.com/vi/' + videoObj.id + '/0.jpg'
          cb(imageURL)
        } else if (videoObj.type === 'vimeo') {
          // Requires jQuery
          $.get('http://vimeo.com/api/v2/video/' + videoObj.id + '.json', function (data) {
            cb(data[0].thumbnail_large)
          })
        }
      }
    }
  }

  if (!HTMLCanvasElement.prototype.toBlob) {
    Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
      value: function (callback, type, quality) {
        var canvas = this
        setTimeout(function () {
          var binStr = atob( canvas.toDataURL(type, quality).split(',')[1] )
          var len = binStr.length
          var arr = new Uint8Array(len)

          for (var i = 0; i < len; i++) {
            arr[i] = binStr.charCodeAt(i)
          }

          callback( new Blob( [arr], {type: type || 'image/png'} ) )
        })
      }
    })
  }
</script>

<style>
  .ql-editor {
    line-height: 1.65;
  }
  .grape-form-wrap[data-form-type="edit-inline"] .ql-container {
    font-size: 15px;
  }
  .grape-edit-close {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 38px;
    font-size: 32px;
    color: #222;
  }
  .grape-edit-close:hover {
    opacity: 0.6;
  }
  .ui-state-highlight {
    width: 100%;
    height: 150px;
    margin: 10px;
    float: left;
    border: none!important;
    background-color: #ddd!important;
  }
  #selected-image-wrap .images {
    padding-left: 10px;
    padding-bottom: 30px;
  }
  #selected-image-wrap .images > div {
    position: relative;
    cursor: pointer;
  }
  #selected-image-wrap .images > div.ui-sortable-helper {
    width: 500px!important;
    max-width: 100%;
  }
  #selected-image-wrap .images > div > span {
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 2;
    background: #222;
    color: #fff;
    padding: 5px;
    font-size: 12px;
    font-weight: bold;
  }
  #selected-image-wrap .images > div > span:empty {
    display: none;
  }
  #selected-image-wrap .images > div > a.remove-image {
    position: absolute;
    top: 0;
    right: 0;
    background: rgba(0,0,0,0.6);
    text-decoration: none;
    color: #fff;
    font-weight: bold;
    font-size: 28px;
    height: 40px;
    line-height: 40px;
    width: 40px;
    text-align: center;
  }
  #selected-image-wrap .images > div > a.remove-image:hover {
    background: rgba(0,0,0,0.9);
  }
  #selected-image-wrap .images > div > a.remove-image:before {
    content: "×";
    display: block;
  }
  .ui-tooltip {
    max-width: 460px;
    padding: 20px;
    box-sizing: border-box;
    font-size: 0.8em;
    line-height: 1.4em;
    box-shadow: 2px 2px 1px rgba(0,0,0,0.4);
  }
  .ui-tooltip .ui-tooltip-content {
    line-height: 180%;
  }
  .source-preview-wrap {
    display: none;
  }
  .source-preview-wrap iframe {
    max-width: 100%;
  }
  .desktop-source-preview-wrap {
    display: none;
  }
  .source-preview-wrap #source-preview {
    background: #f7f7f7;
    margin: 0 0 0 30px;
    padding: 25px;
    display: none;
    height: auto;
    overflow: hidden;
  }
  .source-preview-wrap #source-preview:empty {
    display: none;
  }
  .source-preview-wrap h4 {
    border-bottom: 1px solid #2c3e50;
    padding: 0 0 4px;
    margin: 0 0 20px 30px;
    line-height: 40px;
  }
  .source-preview-wrap h4 span {
    font-size: 0.8em;
    color: #aaa;
    float: right;
  }
  .source-preview-wrap h4 a.source-preview-back {
    float: right;
    width: auto;
    display: none;
  }
  .source-preview-wrap.book-selected #books-table-wrap {
    display: none;
  }
  .source-preview-wrap.book-selected h4 span {
    display: none;
  }
  .source-preview-wrap.book-selected h4 a.source-preview-back {
    display: block;
  }
  .source-preview-wrap.book-selected #source-preview {
    display: block;
  }
  #source-preview .first-line {
    margin-top: 0;
  }
  #source-preview .last-line {
    margin-bottom: 0;
    width: 100%;
    display: block;
    clear: both;
  }
  #source-preview .last-line a {
    float: right;
  }
  #books-table-wrap {
    padding-left: 30px;
    padding-top: 0;
  }
  #books-table {
    font-size: 0.8em;
  }
  #books-table:hover tr {
    opacity: 0.5;
  }
  #books-table tr:hover {
    opacity: 1;
    cursor: pointer;
  }
  #books-table td.image {
    width: 25px;
    padding-right: 20px;
  }
  #books-table td.image > img {
    max-width: 100%;
  }
  #books-table td.title {
    padding: 10px 15px 10px 0;
  }
  #books-table td.author {
    padding: 10px 15px 10px 0;
  }
  #books-table td.year {
    padding: 10px 0;
  }
  .grape-form-wrap form[data-edit-type="edit-inline"] .input-field-source {
    width: 100%!important;
  }
</style>

<style scoped>
  #grape-capture {
    display: none;
  }
  section {
    height: 100vh;
  }

  .grape-form-wrap {
    width: 100%;
    max-width: 1000px;
    margin: 0 auto;
    text-align: left;
  }

  .grape-form-wrap[data-form-type="edit-inline"] form {
      margin: 0 auto;
      width: 80%;
  }

  .direct-edit-link {
    margin-bottom: 20px;
    display: block;
    text-decoration: none;
  }

  .grape-form-divide {
    border: none;
    background: #eee;
    height: 1px;
    margin: 20px 0 40px;
  }

  .grape-form-wrap form fieldset {
    margin-bottom: 50px;
    padding-bottom: 0;
  }
  .grape-form-wrap form label {
    text-align: left;
    margin-top: 0;
    margin-bottom: 8px;
    font-weight: bold;
    clear: both;
  }

  .grape-form-wrap form label > span {
    font-size: 10px;
    line-height: 16px;
    font-weight: normal;
    padding-left: 10px;
    vertical-align: 2px;
  }

  .grape-form-wrap[data-form-type="edit-inline"] form label > span {
    display: none;
  }

  .grape-form-wrap form label > span > img {
    width: 50px;
    display: inline-block;
    vertical-align: middle;
    padding: 0 4px;
  }

  .grape-form-wrap .the-grape-input > button {
    float: left;
    margin: 0 10px 20px 0;
  }

  .delete-text-button {
    display: none;
  }

  .form-divider {
    text-align: center;
    padding: 20px 0 30px;
    font-size: 13px;
    font-weight: bold;
    color: #777;
  }

  .form-divider span {
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
  }

  .form-divider span:after, .form-divider span:before {
    content: '';
    width: 100%;
    height: 2px;
    background: #eee;
    margin: 0 20px 0 0;
  }
  .form-divider span:after {
    margin: 0 0 0 20px;
  }

  .grape-form-wrap form .input-field {
    margin-bottom: 20px;
    clear: both;
  }

  .grape-form-wrap form .input-field.print-upload-source-image > img {
    max-width: 200px;
    height: auto;
  }

  .grape-form-wrap form .input-field-half-left {
    width: 48%;
    float: left;
    clear: left;
  }

  .grape-form-wrap form .input-field-half-right {
    width: 48%;
    float: right;
    clear: right;
  }

  .grape-form-wrap form select {
    width: 100%;
  }

  .grape-form-wrap form input {
    width: 100%;
  }

  .grape-form-wrap form textarea {
    width: 100%;
  }

  .grape-form-wrap form #grape_content {
    visibility: hidden;
    display: none;
  }

  .grape-form-wrap form .spacer {
    display: block;
    height: 0;
  }

  .grape-form-wrap form #grape_editor {
    min-height: 400px;
    margin-bottom: 10px;
  }

  #toolbar {
    margin-top: 20px;
  }
  #toolbar .toolbar-spacer {
    display: inline-block;
    float: left;
    height: 24px;
    padding: 3px 5px;
    width: 24px;
  }

  .grape-form-wrap .character-count {
    font-size: 12px;
    font-weight: bold;
  }

  .grape-form-wrap form button[type=submit] {
    width: 100%;
    margin-top: 40px;
    margin-bottom: 15px;
    line-height: 30px;
  }

  .grape-form-wrap form button[type=submit][disabled] {
    opacity: 0.5;
  }
  .grape-form-wrap[data-form-type="edit-inline"] form button[type=submit] {
    margin-top: 10px;
  }
  
  .grape-form-wrap form button.cancel-button {
    width: 100%;
    line-height: 30px;
  }

  #selected-image-wrap {
    margin: 20px 0 0 20px;
  }

  .reupload-button {
    display: none;
    margin-bottom: 20px;
    margin-left: 10px;
  }

  .grape-form-wrap .word-count.warning {
    font-weight: bold;
    color: red;
  }

  .submit-notice {
    clear: both;
    margin-bottom: 0;
    font-weight: bold;
    color: red;
  }

  .title-notice {
    font-weight: bold;
    font-size: 16px;
    color: #666;
  }

  #get_books {
    width: 100%;
    margin: 0 0 20px;
    padding: 10px;
    display: none;
  }

  .book-grape-count {
    margin-bottom: 20px;
    display: block;
    text-decoration: none;
  }

  @media only screen and (max-width: 1024px) {
    .grape-form-wrap form {
      width: 100%;
      padding: 0 20px;
    }
    .grape-form-wrap form .input-field-half-left, .grape-form-wrap form .input-field-half-right {
      width: 100%;
      float: none;
    }
    .grape-form-wrap form .input-field {
      margin-bottom: 10px;
    }
    .grape-form-wrap form button[type=submit] {
      margin-top: 20px;
    }
    .grape-form-wrap form #grape_editor {
      min-height: 300px;
    }
    .form-divider {
      padding: 20px 0 10px;
    }
    .desktop-source-preview-wrap {
      display: none;
    }
    .mobile-source-preview-wrap h4, .mobile-source-preview-wrap #source-preview, .mobile-source-preview-wrap #selected-image-wrap {
      margin-left: 0;
    }
    .mobile-source-preview-wrap #books-table-wrap {
      padding-left: 0;
    }
    .mobile-source-preview-wrap #source-preview img {
      max-width: 80px;
    }
    .mobile-source-preview-wrap #source-preview .last-line a {
      float: none;
      display: block;
      margin-top: 10px;
    }
    #selected-image-wrap .images {
      padding-left: 0;
    }
    .reupload-button {
      margin-left: 0;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/GrapeForm.vue